var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InstagramBusinessContentCard',{staticClass:"ContentCard",attrs:{"page":_vm.page,"content":_vm.content,"height":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }